package com.shreyasjoshi.components

import androidx.compose.runtime.*
import org.jetbrains.compose.web.dom.*
import com.shreyasjoshi.models.PortfolioData

@Composable
fun ContactSection(isDarkMode: Boolean) {
    val info = PortfolioData.personalInfo

    Section(
        attrs = {
            id("contact")
            classNames(
                "portfolio-section",
                "py-16", "px-4", "sm:px-6", "lg:px-8", "max-w-6xl", "mx-auto", "border-b", "transition-colors",
                if (isDarkMode) "border-white/10" else "border-slate-200"
            )
        }
    ) {
        Div(attrs = { classNames("space-y-10") }) {
            // Header
            Div(attrs = { classNames("space-y-2") }) {
                Div(attrs = { classNames("text-xs", "font-mono", "text-[#189AD3]", "tracking-widest", "uppercase") }) {
                    Text("06 // CONTACT")
                }
                H2(
                    attrs = {
                        classNames(
                            "text-3xl", "font-bold", "tracking-tight",
                            if (isDarkMode) "text-white" else "text-slate-900"
                        )
                    }
                ) {
                    Text("Direct Communication & Professional Inquiries")
                }
                P(
                    attrs = {
                        classNames(
                            "text-sm", "max-w-2xl",
                            if (isDarkMode) "text-white/60" else "text-slate-600"
                        )
                    }
                ) {
                    Text("Available for discussions on Android Automotive OS engineering, AOSP integration, senior technical leadership roles, and technical consulting.")
                }
            }

            // Contact Channels Grid
            Div(attrs = { classNames("grid", "grid-cols-1", "md:grid-cols-2", "gap-6") }) {
                // Email Card
                A(
                    href = "mailto:${info.email}",
                    attrs = {
                        classNames(
                            "p-6", "rounded-sm", "border", "transition-all", "group", "block",
                            if (isDarkMode) "bg-[#0a0a0a] border-white/10 hover:border-[#189AD3]/40"
                            else "bg-slate-50 border-slate-200 hover:border-[#189AD3]/40"
                        )
                    }
                ) {
                    Div(attrs = { classNames("flex", "items-center", "justify-between", "mb-3") }) {
                        Span(attrs = { classNames("text-xs", "font-mono", "text-[#189AD3]", "uppercase") }) {
                            Text("Email Direct")
                        }
                        Span(attrs = { classNames("text-xs", "font-mono", "text-white/40", "group-hover:text-[#189AD3]", "transition-colors") }) {
                            Text("↗")
                        }
                    }
                    H3(
                        attrs = {
                            classNames(
                                "text-lg", "font-bold",
                                if (isDarkMode) "text-white group-hover:text-[#71C7EC]" else "text-slate-900 group-hover:text-sky-800"
                            )
                        }
                    ) {
                        Text(info.email)
                    }
                    P(
                        attrs = {
                            classNames(
                                "text-xs", "mt-2",
                                if (isDarkMode) "text-white/50" else "text-slate-500"
                            )
                        }
                    ) {
                        Text("Fastest channel for technical inquiries, job opportunities, and collaboration.")
                    }
                }

                // LinkedIn Card
                A(
                    href = info.linkedin,
                    attrs = {
                        classNames(
                            "p-6", "rounded-sm", "border", "transition-all", "group", "block",
                            if (isDarkMode) "bg-[#0a0a0a] border-white/10 hover:border-[#189AD3]/40"
                            else "bg-slate-50 border-slate-200 hover:border-[#189AD3]/40"
                        )
                    }
                ) {
                    Div(attrs = { classNames("flex", "items-center", "justify-between", "mb-3") }) {
                        Span(attrs = { classNames("text-xs", "font-mono", "text-[#189AD3]", "uppercase") }) {
                            Text("LinkedIn Profile")
                        }
                        Span(attrs = { classNames("text-xs", "font-mono", "text-white/40", "group-hover:text-[#189AD3]", "transition-colors") }) {
                            Text("↗")
                        }
                    }
                    H3(
                        attrs = {
                            classNames(
                                "text-lg", "font-bold",
                                if (isDarkMode) "text-white group-hover:text-[#71C7EC]" else "text-slate-900 group-hover:text-sky-800"
                            )
                        }
                    ) {
                        Text("linkedin.com/in/sv10joshi")
                    }
                    P(
                        attrs = {
                            classNames(
                                "text-xs", "mt-2",
                                if (isDarkMode) "text-white/50" else "text-slate-500"
                            )
                        }
                    ) {
                        Text("Connect with me for professional updates, recommendations, and networking.")
                    }
                }

                // Location & Readiness
                Div(
                    attrs = {
                        classNames(
                            "p-6", "rounded-sm", "border",
                            if (isDarkMode) "bg-[#0a0a0a] border-white/10" else "bg-slate-50 border-slate-200"
                        )
                    }
                ) {
                    Div(attrs = { classNames("text-xs", "font-mono", "text-[#189AD3]", "uppercase", "mb-3") }) {
                        Text("Current Base & Relocation")
                    }
                    H3(
                        attrs = {
                            classNames(
                                "text-lg", "font-bold",
                                if (isDarkMode) "text-white" else "text-slate-900"
                            )
                        }
                    ) {
                        Text(info.location)
                    }
                    P(
                        attrs = {
                            classNames(
                                "text-xs", "mt-2",
                                if (isDarkMode) "text-white/50" else "text-slate-500"
                            )
                        }
                    ) {
                        Text("Open to on-site/hybrid opportunities in Bengaluru, remote engagements, and international relocation.")
                    }
                }

                // Knowledge Base Direct
                A(
                    href = info.knowledgeBase,
                    attrs = {
                        classNames(
                            "p-6", "rounded-sm", "border", "transition-all", "group", "block",
                            if (isDarkMode) "bg-[#0a0a0a] border-white/10 hover:border-[#189AD3]/40"
                            else "bg-slate-50 border-slate-200 hover:border-[#189AD3]/40"
                        )
                    }
                ) {
                    Div(attrs = { classNames("flex", "items-center", "justify-between", "mb-3") }) {
                        Span(attrs = { classNames("text-xs", "font-mono", "text-[#189AD3]", "uppercase") }) {
                            Text("Technical Blog")
                        }
                        Span(attrs = { classNames("text-xs", "font-mono", "text-white/40", "group-hover:text-[#189AD3]", "transition-colors") }) {
                            Text("↗")
                        }
                    }
                    H3(
                        attrs = {
                            classNames(
                                "text-lg", "font-bold",
                                if (isDarkMode) "text-white group-hover:text-[#71C7EC]" else "text-slate-900 group-hover:text-sky-800"
                            )
                        }
                    ) {
                        Text("notes.shreyasjoshi.in")
                    }
                    P(
                        attrs = {
                            classNames(
                                "text-xs", "mt-2",
                                if (isDarkMode) "text-white/50" else "text-slate-500"
                            )
                        }
                    ) {
                        Text("Explore technical write-ups covering AOSP internals, SWE traceability, and Kotlin patterns.")
                    }
                }
            }
        }
    }
}


